import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';

import { Link } from 'react-router-dom'
import Ruchen from './Ruchen'
import LAZY from './LAZY'
import './App.css';

class iOSApp extends Component {
  render() {
    return (
      <div>
        <Link to="/Ruchen">Ruchen</Link>
        <br/>
        <Link to="/LAZY">iOSApp</Link>
      </div>
    );
  }
}

export default iOSApp;